const ApplicationState = {
  REGISTERED: {
    id: 0,
    group: 'APPLICATION_STATE',
    name: 'APPST_REGISTERED',
    label: '신규접수',
  },

  CONSULT_ONGOING: {
    id: 1,
    group: 'APPLICATION_STATE',
    name: 'APPST_CONSULT_ONGOING',
    label: '상담 진행중',
  },

  COMPLETED: {
    id: 2,
    group: 'APPLICATION_STATE',
    name: 'APPST_COMPLETED',
    label: '접수완료',
  },

  NO_RESPONSE: {
    id: 3,
    group: 'APPLICATION_STATE',
    name: 'APPST_NO_RESPONSE',
    label: '미응답',
  },

  CANCELED: {
    id: 4,
    group: 'APPLICATION_STATE',
    name: 'APPST_CANCELED',
    label: '접수취소',
  },

  get values() {
    return [
      this.REGISTERED,
      this.CONSULT_ONGOING,
      this.COMPLETED,
      this.NO_RESPONSE,
      this.CANCELED,
    ];
  },
};

const ApplicationTagCategory = {
  FUNNEL: {
    id: 0,
    group: 'APPLICATION_TAG_CATEGORY',
    name: 'APPTC_FUNNEL',
    label: '유입경로',
  },

  USE_PURPOSE: {
    id: 1,
    group: 'APPLICATION_TAG_CATEGORY',
    name: 'APPTC_USE_PURPOSE',
    label: '사용목적',
  },

  get values() {
    return [
      this.FUNNEL,
      this.USE_PURPOSE,
    ];
  },
};

const InsurancePriceType = {
  ONE_MILLION: {
    id: 0,
    group: 'INSURANCE_PRICE_TYPE',
    name: 'ISPTY_ONE_MILLION',
    label: '자기부담금 100만원',
  },

  HALF_MILLION: {
    id: 1,
    group: 'INSURANCE_PRICE_TYPE',
    name: 'ISPTY_HALF_MILLION',
    label: '자기부담금 50만원',
  },

  get values() {
    return [
      this.ONE_MILLION,
      this.HALF_MILLION,
    ];
  },
};

const InsurancePriceAgeType = {
  AGE_26_UP: {
    id: 0,
    group: 'INSURANCE_PRICE_AGE_TYPE',
    name: 'ISPTY_AGE_26_UP',
    label: '만 26세 이상',
  },

  AGE_26_DOWN: {
    id: 1,
    group: 'INSURANCE_PRICE_AGE_TYPE',
    name: 'ISPTY_AGE_26_DOWN',
    label: '만 26세 미만',
  },

  get values() {
    return [
      this.AGE_26_UP,
      this.AGE_26_DOWN,
    ];
  },
};

const ContractState = {
  REGISTERED: {
    id: 0,
    group: 'CONTRACT_STATE',
    name: 'CTRST_REGISTERED',
    label: '신규접수',
  },

  COMPLETED: {
    id: 1,
    group: 'CONTRACT_STATE',
    name: 'CTRST_COMPLETED',
    label: '계약완료 (결제완료)',
  },

  RENEWAL_REGISTERED: {
    id: 2,
    group: 'CONTRACT_STATE',
    name: 'CTRST_RENEWAL_REGISTERED',
    label: '연장접수',
  },

  RENEWAL_COMPLETED: {
    id: 3,
    group: 'CONTRACT_STATE',
    name: 'CTRST_RENEWAL_COMPLETED',
    label: '연장완료',
  },

  TERMINATED_BEFORE_RENT_START: {
    id: 4,
    group: 'CONTRACT_STATE',
    name: 'CTRST_TERMINATED_BEFORE_RENT_START',
    label: '계약해지 (대여시작 전)',
  },

  TERMINATED: {
    id: 5,
    group: 'CONTRACT_STATE',
    name: 'CTRST_TERMINATED',
    label: '계약해지',
  },

  EXPIRED: {
    id: 6,
    group: 'CONTRACT_STATE',
    name: 'CTRST_EXPIRED',
    label: '계약만료',
  },

  CANCELED: {
    id: 7,
    group: 'CONTRACT_STATE',
    name: 'CTRST_CANCELED',
    label: '접수취소',
  },

  get values() {
    return [
      this.REGISTERED,
      this.COMPLETED,
      this.RENEWAL_REGISTERED,
      this.RENEWAL_COMPLETED,
      this.TERMINATED_BEFORE_RENT_START,
      this.TERMINATED,
      this.EXPIRED,
      this.CANCELED,
    ];
  },
};

const WarrantyTarget = {
  NON_TARGET: {
    id: 0,
    group: 'WARRANTY_TARGET',
    name: 'WRTTG_NON_TARGET',
    label: '미대상',
  },

  PCT_10_TARGET: {
    id: 1,
    group: 'WARRANTY_TARGET',
    name: 'WRTTG_PCT_10_TARGET',
    label: '대상 (10%)',
  },

  PCT_20_TARGET: {
    id: 2,
    group: 'WARRANTY_TARGET',
    name: 'WRTTG_PCT_20_TARGET',
    label: '대상 (20%)',
  },

  get values() {
    return [
      this.NON_TARGET,
      this.PCT_10_TARGET,
      this.PCT_20_TARGET,
    ];
  },
};

const WarrantyType = {
  INSURANCE: {
    id: 0,
    group: 'WARRANTY_TYPE',
    name: 'WRTTY_INSURANCE',
    label: '보증보험',
  },

  DEPOSIT: {
    id: 1,
    group: 'WARRANTY_TYPE',
    name: 'WRTTY_DEPOSIT',
    label: '보증금',
  },

  get values() {
    return [
      this.INSURANCE,
      this.DEPOSIT,
    ];
  },
};

const WarrantyProcessState = {
  SHEET_NON_CONNECTED: {
    id: 0,
    group: 'WARRANTY_PROCESS_STATE',
    name: 'WPRST_SHEET_NON_CONNECTED',
    label: '시트 연동 전',
  },

  SHEET_CONNECTED: {
    id: 1,
    group: 'WARRANTY_PROCESS_STATE',
    name: 'WPRST_SHEET_CONNECTED',
    label: '시트 연동완료',
  },

  SHEET_EXPIRED: {
    id: 2,
    group: 'WARRANTY_PROCESS_STATE',
    name: 'WPRST_SHEET_EXPIRED',
    label: '시트 연동만료',
  },

  DEPOSIT_NON_CHARGED: {
    id: 3,
    group: 'WARRANTY_PROCESS_STATE',
    name: 'WPRST_DEPOSIT_NON_CHARGED',
    label: '청구 전',
  },

  DEPOSIT_CHARGED: {
    id: 4,
    group: 'WARRANTY_PROCESS_STATE',
    name: 'WPRST_DEPOSIT_CHARGED',
    label: '청구완료',
  },

  CANCELED: {
    id: 5,
    group: 'WARRANTY_PROCESS_STATE',
    name: 'WPRST_CANCELED',
    label: '취소',
  },

  get values() {
    return [
      this.SHEET_NON_CONNECTED,
      this.SHEET_CONNECTED,
      this.SHEET_EXPIRED,
      this.DEPOSIT_NON_CHARGED,
      this.DEPOSIT_CHARGED,
      this.CANCELED,
    ];
  },
};

const WarrantyPurchaseState = {
  ONGOING: {
    id: 0,
    group: 'WARRANTY_PURCHASE_STATE',
    name: 'WPCST_ONGOING',
    label: '구입 진행중',
  },

  COMPLETED: {
    id: 1,
    group: 'WARRANTY_PURCHASE_STATE',
    name: 'WPCST_COMPLETED',
    label: '구입완료',
  },

  NON_PURCHASABLE: {
    id: 2,
    group: 'WARRANTY_PURCHASE_STATE',
    name: 'WPCST_NON_PURCHASABLE',
    label: '구입불가',
  },

  CANCELED: {
    id: 3,
    group: 'WARRANTY_PURCHASE_STATE',
    name: 'WPCST_CANCELED',
    label: '구입취소',
  },

  get values() {
    return [
      this.ONGOING,
      this.COMPLETED,
      this.NON_PURCHASABLE,
      this.CANCELED,
    ];
  },
};

const ContractDocumentType = {
  FIRST_CONTRACT: {
    id: 0,
    group: 'CONTRACT_DOCUMENT_TYPE',
    name: 'CTDTY_FIRST_CONTRACT',
    label: '최초계약',
  },

  NEW_CONTRACT: {
    id: 1,
    group: 'CONTRACT_DOCUMENT_TYPE',
    name: 'CTDTY_NEW_CONTRACT',
    label: '신규계약',
  },

  RENEWAL_CONTRACT: {
    id: 2,
    group: 'CONTRACT_DOCUMENT_TYPE',
    name: 'CTDTY_RENEWAL_CONTRACT',
    label: '신규계약-연장',
  },

  CAR_CHANGED: {
    id: 3,
    group: 'CONTRACT_DOCUMENT_TYPE',
    name: 'CTDTY_CAR_CHANGED',
    label: '차량번호 변경',
  },

  CAR_TYPE_CHANGED: {
    id: 4,
    group: 'CONTRACT_DOCUMENT_TYPE',
    name: 'CTDTY_CAR_TYPE_CHANGED',
    label: '차종 변경',
  },

  PERIOD_CHANGED: {
    id: 5,
    group: 'CONTRACT_DOCUMENT_TYPE',
    name: 'CTDTY_PERIOD_CHANGED',
    label: '대여기간 변경',
  },

  MEMBER_INFO_FIXED: {
    id: 6,
    group: 'CONTRACT_DOCUMENT_TYPE',
    name: 'CTDTY_MEMBER_INFO_FIXED',
    label: '고객정보 오기입',
  },

  SIMPLE_INFO_FIXED: {
    id: 7,
    group: 'CONTRACT_DOCUMENT_TYPE',
    name: 'CTDTY_SIMPLE_INFO_FIXED',
    label: '단순정보 오기입',
  },

  ETC: {
    id: 8,
    group: 'CONTRACT_DOCUMENT_TYPE',
    name: 'CTDTY_ETC',
    label: '기타',
  },

  get values() {
    return [
      this.FIRST_CONTRACT,
      this.NEW_CONTRACT,
      this.RENEWAL_CONTRACT,
      this.CAR_CHANGED,
      this.CAR_TYPE_CHANGED,
      this.PERIOD_CHANGED,
      this.MEMBER_INFO_FIXED,
      this.SIMPLE_INFO_FIXED,
      this.ETC,
    ];
  },
};

const ContractDocumentTarget = {
  MEMBER: {
    id: 0,
    group: 'CONTRACT_DOCUMENT_TARGET',
    name: 'CTDTG_MEMBER',
    label: '회원',
  },

  COMPANY: {
    id: 1,
    group: 'CONTRACT_DOCUMENT_TARGET',
    name: 'CTDTG_COMPANY',
    label: '보증보험사',
  },

  get values() {
    return [
      this.MEMBER,
      this.COMPANY,
    ];
  },
};

const CarConsignmentState = {
  SCHEDULED: {
    id: 0,
    group: 'CAR_CONSIGNMENT_STATE',
    name: 'CSNST_SCHEDULED',
    label: '대기중',
  },

  HANDLE_SCHEDULED: {
    id: 1,
    group: 'CAR_CONSIGNMENT_STATE',
    name: 'CSNST_HANDLE_SCHEDULED',
    label: '핸들등록',
  },

  HANDLE_DRIVING: {
    id: 2,
    group: 'CAR_CONSIGNMENT_STATE',
    name: 'CSNST_HANDLE_DRIVING',
    label: '핸들운행중',
  },

  COMPLETED: {
    id: 3,
    group: 'CAR_CONSIGNMENT_STATE',
    name: 'CSNST_COMPLETED',
    label: '완료',
  },

  CANCELED: {
    id: 4,
    group: 'CAR_CONSIGNMENT_STATE',
    name: 'CSNST_CANCELED',
    label: '취소',
  },

  get values() {
    return [
      this.SCHEDULED,
      this.HANDLE_SCHEDULED,
      this.HANDLE_DRIVING,
      this.COMPLETED,
      this.CANCELED,
    ];
  },
};

const CarGradeType = {
  A_GRADE: {
    id: 0,
    group: 'CAR_GRADE_TYPE',
    name: 'CGDTY_A_GRADE',
    label: 'A',
  },

  B_GRADE: {
    id: 1,
    group: 'CAR_GRADE_TYPE',
    name: 'CGDTY_B_GRADE',
    label: 'B',
  },

  C_GRADE: {
    id: 2,
    group: 'CAR_GRADE_TYPE',
    name: 'CGDTY_C_GRADE',
    label: 'C',
  },

  D_GRADE: {
    id: 3,
    group: 'CAR_GRADE_TYPE',
    name: 'CGDTY_D_GRADE',
    label: 'D',
  },

  get values() {
    return [
      this.A_GRADE,
      this.B_GRADE,
      this.C_GRADE,
      this.D_GRADE,
    ];
  },
};

const CarConsignmentType = {
  ASSIGN: {
    id: 0,
    group: 'CAR_CONSIGNMENT_TYPE',
    name: 'CSNTY_ASSIGN',
    label: '인수 (최초)',
  },

  RETURN: {
    id: 1,
    group: 'CAR_CONSIGNMENT_TYPE',
    name: 'CSNTY_RETURN',
    label: '반납 (최종)',
  },

  ASSIGN_FOR_CAR_CHANGE: {
    id: 2,
    group: 'CAR_CONSIGNMENT_TYPE',
    name: 'CSNTY_ASSIGN_FOR_CAR_CHANGE',
    label: '인수 (차량교체)',
  },

  RETURN_FOR_CAR_CHANGE: {
    id: 3,
    group: 'CAR_CONSIGNMENT_TYPE',
    name: 'CSNTY_RETURN_FOR_CAR_CHANGE',
    label: '반납 (차량교체)',
  },

  get values() {
    return [
      this.ASSIGN,
      this.RETURN,
      this.ASSIGN_FOR_CAR_CHANGE,
      this.RETURN_FOR_CAR_CHANGE,
    ];
  },
};

const CarConsignmentMethod = {
  SELF_PICKUP: {
    id: 0,
    group: 'CAR_CONSIGNMENT_METHOD',
    name: 'CSNHD_SELF_PICKUP',
    label: '자체픽업',
  },

  HANDLE_RESERVATION: {
    id: 1,
    group: 'CAR_CONSIGNMENT_METHOD',
    name: 'CSNHD_HANDLE_RESERVATION',
    label: '핸들예약',
  },

  get values() {
    return [
      this.SELF_PICKUP,
      this.HANDLE_RESERVATION,
    ];
  },
};

const AttachmentType = {
  CAR_TAKE_OVER_RECEIPT: {
    id: 0,
    group: 'ATTACHMENT_TYPE',
    name: 'ATCTY_CAR_TAKE_OVER_RECEIPT',
    label: '차량 인수증',
  },

  get values() {
    return [
      this.CAR_TAKE_OVER_RECEIPT,
    ];
  },
};

const HistoryContentType = {
  CHANGE_LOG: {
    id: 0,
    group: 'HISTORY_CONTENT_TYPE',
    name: 'HICTY_CHANGE_LOG',
    label: '변경이력',
  },

  MEMO: {
    id: 1,
    group: 'HISTORY_CONTENT_TYPE',
    name: 'HICTY_MEMO',
    label: '메모',
  },

  CONSULT: {
    id: 2,
    group: 'HISTORY_CONTENT_TYPE',
    name: 'HICTY_CONSULT',
    label: '상담',
  },

  get values() {
    return [
      this.CHANGE_LOG,
      this.MEMO,
      this.CONSULT,
    ];
  },
};

const ManagerType = {
  NORMAL: {
    id: 0,
    group: 'MANAGER_TYPE',
    name: 'MNGTY_NORMAL',
    label: '일반',
  },

  TEAM_LEADER: {
    id: 1,
    group: 'MANAGER_TYPE',
    name: 'MNGTY_TEAM_LEADER',
    label: '팀장',
  },

  GROUP_LEADER: {
    id: 2,
    group: 'MANAGER_TYPE',
    name: 'MNGTY_GROUP_LEADER',
    label: '그룹장',
  },

  HQ_LEADER: {
    id: 3,
    group: 'MANAGER_TYPE',
    name: 'MNGTY_HQ_LEADER',
    label: '본부장',
  },

  get values() {
    return [
      this.NORMAL,
      this.TEAM_LEADER,
      this.GROUP_LEADER,
      this.HQ_LEADER,
    ];
  },
};

const CategoryType = {
  APPLICATION_HISTORY: {
    id: 0,
    group: 'CATEGORY_TYPE',
    name: 'CTGTY_APPLICATION_HISTORY',
    label: '신청 히스토리',
  },

  CONTRACT_HISTORY: {
    id: 1,
    group: 'CATEGORY_TYPE',
    name: 'CTGTY_CONTRACT_HISTORY',
    label: '계약 히스토리',
  },

  SETTLEMENT_HISTORY: {
    id: 2,
    group: 'CATEGORY_TYPE',
    name: 'CTGTY_SETTLEMENT_HISTORY',
    label: '청구/결제 히스토리',
  },

  CAR_PRODTZ_HISTORY: {
    id: 3,
    group: 'CATEGORY_TYPE',
    name: 'CTGTY_CAR_PRODTZ_HISTORY',
    label: '상품화 히스토리',
  },

  CAR_HISTORY: {
    id: 4,
    group: 'CATEGORY_TYPE',
    name: 'CTGTY_CAR_HISTORY',
    label: '차량 히스토리',
  },

  FOLLOWUP_HISTORY: {
    id: 5,
    group: 'CATEGORY_TYPE',
    name: 'CTGTY_FOLLOWUP_HISTORY',
    label: '후속조치 히스토리',
  },

  FOLLOWUP_CATEGORY: {
    id: 6,
    group: 'CATEGORY_TYPE',
    name: 'CTGTY_FOLLOWUP_CATEGORY',
    label: '후속조치 카테고리',
  },

  ASSIGN_REGISTER_REASON: {
    id: 7,
    group: 'CATEGORY_TYPE',
    name: 'CTGTY_ASSIGN_REGISTER_REASON',
    label: '인수 등록사유',
  },

  OCCUPANCY_REGISTER_REASON: {
    id: 8,
    group: 'CATEGORY_TYPE',
    name: 'CTGTY_OCCUPANCY_REGISTER_REASON',
    label: '차량 스케줄 등록사유',
  },

  get values() {
    return [
      this.APPLICATION_HISTORY,
      this.CONTRACT_HISTORY,
      this.SETTLEMENT_HISTORY,
      this.CAR_PRODTZ_HISTORY,
      this.CAR_HISTORY,
      this.FOLLOWUP_HISTORY,
      this.FOLLOWUP_CATEGORY,
      this.ASSIGN_REGISTER_REASON,
      this.OCCUPANCY_REGISTER_REASON,
    ];
  },
};

const SettlementType = {
  AUTO: {
    id: 0,
    group: 'SETTLEMENT_TYPE',
    name: 'STLTP_AUTO',
    label: '자동',
  },

  MANUAL: {
    id: 1,
    group: 'SETTLEMENT_TYPE',
    name: 'STLTP_MANUAL',
    label: '수동',
  },

  get values() {
    return [
      this.AUTO,
      this.MANUAL,
    ];
  },
};

const SettlementChargeType = {
  REGULAR: {
    id: 0,
    group: 'SETTLEMENT_CHARGE_TYPE',
    name: 'SCHTP_REGULAR',
    label: '월 정기',
  },

  REGULAR_DAILY: {
    id: 1,
    group: 'SETTLEMENT_CHARGE_TYPE',
    name: 'SCHTP_REGULAR_DAILY',
    label: '월 정기 (일할결제)',
  },

  INDIVIDUAL: {
    id: 2,
    group: 'SETTLEMENT_CHARGE_TYPE',
    name: 'SCHTP_INDIVIDUAL',
    label: '개별',
  },

  RETURN: {
    id: 3,
    group: 'SETTLEMENT_CHARGE_TYPE',
    name: 'SCHTP_RETURN',
    label: '반납',
  },

  ETC: {
    id: 4,
    group: 'SETTLEMENT_CHARGE_TYPE',
    name: 'SCHTP_ETC',
    label: '기타',
  },

  get values() {
    return [
      this.REGULAR,
      this.REGULAR_DAILY,
      this.INDIVIDUAL,
      this.RETURN,
      this.ETC,
    ];
  },
};

const SettlementPaymentType = {
  CARD: {
    id: 0,
    group: 'SETTLEMENT_PAYMENT_TYPE',
    name: 'STPTY_CARD',
    label: '카드결제',
  },

  PARENT_ACCOUNT: {
    id: 1,
    group: 'SETTLEMENT_PAYMENT_TYPE',
    name: 'STPTY_PARENT_ACCOUNT',
    label: '가상계좌',
  },

  FORCE: {
    id: 2,
    group: 'SETTLEMENT_PAYMENT_TYPE',
    name: 'STPTY_FORCE',
    label: '임의처리',
  },

  get values() {
    return [
      this.CARD,
      this.PARENT_ACCOUNT,
      this.FORCE,
    ];
  },
};

const SettlementChargeState = {
  CHARGE_SCHEDULED: {
    id: 0,
    group: 'SETTLEMENT_CHARGE_STATE',
    name: 'STCST_CHARGE_SCHEDULED',
    label: '청구예정',
  },

  CHARGE_COMPLETED: {
    id: 1,
    group: 'SETTLEMENT_CHARGE_STATE',
    name: 'STCST_CHARGE_COMPLETED',
    label: '청구완료',
  },

  CHARGE_CANCELED: {
    id: 2,
    group: 'SETTLEMENT_CHARGE_STATE',
    name: 'STCST_CHARGE_CANCELED',
    label: '청구취소',
  },

  get values() {
    return [
      this.CHARGE_SCHEDULED,
      this.CHARGE_COMPLETED,
      this.CHARGE_CANCELED,
    ];
  },
};

const SettlementState = {
  SETTLEMENT_WAITING: {
    id: 0,
    group: 'SETTLEMENT_STATE',
    name: 'STLST_SETTLEMENT_WAITING',
    label: '대기중',
  },

  SETTLEMENT_UNPAID: {
    id: 1,
    group: 'SETTLEMENT_STATE',
    name: 'STLST_SETTLEMENT_UNPAID',
    label: '미납',
  },

  SETTLEMENT_COMPLETED: {
    id: 2,
    group: 'SETTLEMENT_STATE',
    name: 'STLST_SETTLEMENT_COMPLETED',
    label: '완료',
  },

  SETTLEMENT_CANCELED: {
    id: 3,
    group: 'SETTLEMENT_STATE',
    name: 'STLST_SETTLEMENT_CANCELED',
    label: '취소',
  },

  get values() {
    return [
      this.SETTLEMENT_WAITING,
      this.SETTLEMENT_UNPAID,
      this.SETTLEMENT_COMPLETED,
      this.SETTLEMENT_CANCELED,
    ];
  },
};

const SettlementItemType = {
  MONTHLY_RENT: {
    id: 0,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_MONTHLY_RENT',
    label: '대여요금',
  },

  INSURANCE: {
    id: 1,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_INSURANCE',
    label: '면책상품 요금',
  },

  REPAIR_SERVICE: {
    id: 2,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_REPAIR_SERVICE',
    label: '정비 서비스',
  },

  FELLOW_DRIVER: {
    id: 3,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_FELLOW_DRIVER',
    label: '추가운전자',
  },

  DEPOSIT: {
    id: 4,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_DEPOSIT',
    label: '보증금',
  },

  TAKE_OVER_CONSIGNMENT: {
    id: 5,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_TAKE_OVER_CONSIGNMENT',
    label: '인수탁송',
  },

  INSPECTION_REPAIR: {
    id: 6,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_INSPECTION_REPAIR',
    label: '점검 수리비',
  },

  HIPASS_UNPAID: {
    id: 7,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_HIPASS_UNPAID',
    label: '하이패스 미납',
  },

  HIPASS_FEE: {
    id: 8,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_HIPASS_FEE',
    label: '하이패스 처리 수수료',
  },

  OVER_DISTANCE: {
    id: 9,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_OVER_DISTANCE',
    label: '약정 주행거리 초과비용',
  },

  REFUELING: {
    id: 10,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_REFUELING',
    label: '주유비용',
  },

  RETURN_CONSIGNMENT: {
    id: 11,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_RETURN_CONSIGNMENT',
    label: '반차탁송',
  },

  OVERDUE_INTEREST: {
    id: 12,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_OVERDUE_INTEREST',
    label: '연체이자',
  },

  SHARING_DISCOUNT: {
    id: 13,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_SHARING_DISCOUNT',
    label: '공유할인',
  },

  SHARING_DISCOUNT_CANCEL: {
    id: 14,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_SHARING_DISCOUNT_CANCEL',
    label: '공유할인 취소',
  },

  DRIVING_FEE: {
    id: 15,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_DRIVING_FEE',
    label: '주행요금',
  },

  PENALTY_LESS_7D_BEFORE_RENT_START: {
    id: 16,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_PENALTY_LESS_7D_BEFORE_RENT_START',
    label: '위약금 (대여시작 전 7일 이하)',
  },

  PENALTY_OVER_7D_BEFORE_RENT_START: {
    id: 17,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_PENALTY_OVER_7D_BEFORE_RENT_START',
    label: '위약금 (대여시작 전 7일 초과)',
  },

  PENALTY_UNDER_2M_CONTRACT: {
    id: 18,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_PENALTY_UNDER_2M_CONTRACT',
    label: '위약금 (2개월 미만 계약)',
  },

  PENALTY_MORE_2M_CONTRACT: {
    id: 19,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_PENALTY_MORE_2M_CONTRACT',
    label: '위약금 (2개월 이상 계약)',
  },

  PENALTY_ETC: {
    id: 20,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_PENALTY_ETC',
    label: '패널티',
  },

  FINE: {
    id: 21,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_FINE',
    label: '과태료',
  },

  CAR_INSPECTION_LATE_FINE: {
    id: 22,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_CAR_INSPECTION_LATE_FINE',
    label: '자동차검사 지연 과태료',
  },

  OWNERSHIP_CHANGE_CANCEL_WITH_TAX: {
    id: 23,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_OWNERSHIP_CHANGE_CANCEL_WITH_TAX',
    label: '명의이전 취소 (과세)',
  },

  OWNERSHIP_CHANGE_CANCEL_WITHOUT_TAX: {
    id: 24,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_OWNERSHIP_CHANGE_CANCEL_WITHOUT_TAX',
    label: '명의이전 취소 (비과세)',
  },

  RETURN_EXTEND: {
    id: 25,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_RETURN_EXTEND',
    label: '반납연장',
  },

  PENALTY_BEFORE_ASSIGN: {
    id: 26,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_PENALTY_BEFORE_ASSIGN',
    label: '위약금 (계약후 차량인수 전)',
    deleted: 'true',
  },

  PENALTY_UNDER_6M_CONTRACT: {
    id: 27,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_PENALTY_UNDER_6M_CONTRACT',
    label: '위약금 (6개월 미만 계약)',
    deleted: 'true',
  },

  PENALTY_OVER_6M_CONTRACT: {
    id: 28,
    group: 'SETTLEMENT_ITEM_TYPE',
    name: 'STITY_PENALTY_OVER_6M_CONTRACT',
    label: '위약금 (6개월 이상 계약)',
    deleted: 'true',
  },

  get values() {
    return [
      this.MONTHLY_RENT,
      this.INSURANCE,
      this.REPAIR_SERVICE,
      this.FELLOW_DRIVER,
      this.DEPOSIT,
      this.TAKE_OVER_CONSIGNMENT,
      this.INSPECTION_REPAIR,
      this.HIPASS_UNPAID,
      this.HIPASS_FEE,
      this.OVER_DISTANCE,
      this.REFUELING,
      this.RETURN_CONSIGNMENT,
      this.OVERDUE_INTEREST,
      this.SHARING_DISCOUNT,
      this.SHARING_DISCOUNT_CANCEL,
      this.DRIVING_FEE,
      this.PENALTY_LESS_7D_BEFORE_RENT_START,
      this.PENALTY_OVER_7D_BEFORE_RENT_START,
      this.PENALTY_UNDER_2M_CONTRACT,
      this.PENALTY_MORE_2M_CONTRACT,
      this.PENALTY_ETC,
      this.FINE,
      this.CAR_INSPECTION_LATE_FINE,
      this.OWNERSHIP_CHANGE_CANCEL_WITH_TAX,
      this.OWNERSHIP_CHANGE_CANCEL_WITHOUT_TAX,
      this.RETURN_EXTEND,
      this.PENALTY_BEFORE_ASSIGN,
      this.PENALTY_UNDER_6M_CONTRACT,
      this.PENALTY_OVER_6M_CONTRACT,
    ];
  },
};

const SettlementAccountingType = {
  CHARGE: {
    id: 0,
    group: 'SETTLEMENT_ACCOUNTING_TYPE',
    name: 'STATY_CHARGE',
    label: '과금',
  },

  CHARGE_CANCEL: {
    id: 1,
    group: 'SETTLEMENT_ACCOUNTING_TYPE',
    name: 'STATY_CHARGE_CANCEL',
    label: '과금 취소',
  },

  get values() {
    return [
      this.CHARGE,
      this.CHARGE_CANCEL,
    ];
  },
};

const SettlementPaymentState = {
  PAYMENT_COMPLETED: {
    id: 0,
    group: 'SETTLEMENT_PAYMENT_STATE',
    name: 'STPST_PAYMENT_COMPLETED',
    label: '결제완료',
  },

  PAYMENT_FAILED: {
    id: 1,
    group: 'SETTLEMENT_PAYMENT_STATE',
    name: 'STPST_PAYMENT_FAILED',
    label: '결제실패',
  },

  REFUND_COMPLETED: {
    id: 2,
    group: 'SETTLEMENT_PAYMENT_STATE',
    name: 'STPST_REFUND_COMPLETED',
    label: '환불완료',
  },

  get values() {
    return [
      this.PAYMENT_COMPLETED,
      this.PAYMENT_FAILED,
      this.REFUND_COMPLETED,
    ];
  },
};

const ExcelType = {
  SETTLEMENT_ITEM: {
    id: 0,
    group: 'EXCEL_TYPE',
    name: 'EXLTP_SETTLEMENT_ITEM',
    label: '플랜청구항목',
  },

  SETTLEMENT_PAYMENT: {
    id: 1,
    group: 'EXCEL_TYPE',
    name: 'EXLTP_SETTLEMENT_PAYMENT',
    label: '플랜결제내역',
  },

  PRICE_UPLOAD_FORM: {
    id: 2,
    group: 'EXCEL_TYPE',
    name: 'EXLTP_PRICE_UPLOAD_FORM',
    label: '요금제업로드양식',
  },

  get values() {
    return [
      this.SETTLEMENT_ITEM,
      this.SETTLEMENT_PAYMENT,
      this.PRICE_UPLOAD_FORM,
    ];
  },
};

const ExcelUploadState = {
  REQUESTED: {
    id: 0,
    group: 'EXCEL_UPLOAD_STATE',
    name: 'EXUST_REQUESTED',
    label: '요청됨',
  },

  PROCESSING: {
    id: 1,
    group: 'EXCEL_UPLOAD_STATE',
    name: 'EXUST_PROCESSING',
    label: '처리중',
  },

  FAIL: {
    id: 2,
    group: 'EXCEL_UPLOAD_STATE',
    name: 'EXUST_FAIL',
    label: '실패',
  },

  COMPLETE: {
    id: 3,
    group: 'EXCEL_UPLOAD_STATE',
    name: 'EXUST_COMPLETE',
    label: '완료',
  },

  get values() {
    return [
      this.REQUESTED,
      this.PROCESSING,
      this.FAIL,
      this.COMPLETE,
    ];
  },
};

const ExcelDownloadState = {
  REQUESTED: {
    id: 0,
    group: 'EXCEL_DOWNLOAD_STATE',
    name: 'EXDST_REQUESTED',
    label: '요청됨',
  },

  PROCESSING: {
    id: 1,
    group: 'EXCEL_DOWNLOAD_STATE',
    name: 'EXDST_PROCESSING',
    label: '처리중',
  },

  FAIL: {
    id: 2,
    group: 'EXCEL_DOWNLOAD_STATE',
    name: 'EXDST_FAIL',
    label: '실패',
  },

  COMPLETE: {
    id: 3,
    group: 'EXCEL_DOWNLOAD_STATE',
    name: 'EXDST_COMPLETE',
    label: '완료',
  },

  get values() {
    return [
      this.REQUESTED,
      this.PROCESSING,
      this.FAIL,
      this.COMPLETE,
    ];
  },
};

const ZipFileType = {
  CONTRACT_ATTACHMENT: {
    id: 0,
    group: 'ZIP_FILE_TYPE',
    name: 'ZIFTP_CONTRACT_ATTACHMENT',
    label: '계약 첨부파일',
  },

  get values() {
    return [
      this.CONTRACT_ATTACHMENT,
    ];
  },
};

const ZipFileDownloadState = {
  REQUESTED: {
    id: 0,
    group: 'ZIP_FILE_DOWNLOAD_STATE',
    name: 'ZFDST_REQUESTED',
    label: '요청됨',
  },

  PROCESSING: {
    id: 1,
    group: 'ZIP_FILE_DOWNLOAD_STATE',
    name: 'ZFDST_PROCESSING',
    label: '처리중',
  },

  FAIL: {
    id: 2,
    group: 'ZIP_FILE_DOWNLOAD_STATE',
    name: 'ZFDST_FAIL',
    label: '실패',
  },

  COMPLETE: {
    id: 3,
    group: 'ZIP_FILE_DOWNLOAD_STATE',
    name: 'ZFDST_COMPLETE',
    label: '완료',
  },

  get values() {
    return [
      this.REQUESTED,
      this.PROCESSING,
      this.FAIL,
      this.COMPLETE,
    ];
  },
};

const SmsSendHistoryType = {
  INITIAL_CONTRACT: {
    id: 0,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_INITIAL_CONTRACT',
    label: '최초 계약정보',
  },

  CREDIT_CHECK_FAIL: {
    id: 1,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_CREDIT_CHECK_FAIL',
    label: '신용조회 실패',
  },

  FELLOW_DRIVER: {
    id: 2,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_FELLOW_DRIVER_INFO',
    label: '추가운전자 등록',
  },

  FELLOW_DRIVER_CONTRACTOR: {
    id: 3,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_FELLOW_DRIVER_CONTRACTOR_INFO',
    label: '추가운전자 등록(계약자)',
  },

  DEPOSIT_INFO: {
    id: 4,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_DEPOSIT_INFO',
    label: '보증금 안내',
  },

  INSURANCE_INFO: {
    id: 5,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_INSURANCE_INFO',
    label: '보증보험 안내',
  },

  PLAN_INFO: {
    id: 6,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_PLAN_INFO',
    label: '플랜 안내',
  },

  WARRANTY_CONDITION_FAIL_INFO: {
    id: 7,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_WARRANTY_CONDITION_FAIL_INFO',
    label: '보증조건 미충족 안내',
  },

  DEPOSIT_CONFIRM: {
    id: 8,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_DEPOSIT_CONFIRM',
    label: '보증금 입금 확인 안내',
  },

  WARRANTY_CONDITION_FAIL_CONTRACT_CANCEL: {
    id: 9,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_WARRANTY_CONDITION_FAIL_CONTRACT_CANCEL',
    label: '보증조건 미충으로 인한 계약 취소',
  },

  CONTRACT_TERMINATION_BEFORE: {
    id: 10,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_CONTRACT_TERMINATION_BEFORE',
    label: ' 계약 해지 안내(대여 시작일 전)',
  },

  CONTRACT_TERMINATION_AFTER: {
    id: 11,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_CONTRACT_TERMINATION_AFTER',
    label: ' 계약 해지 안내(대여 시작일 후)',
  },

  TAKE_OVER_INFO: {
    id: 12,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_TAKE_OVER_INFO',
    label: '인수 정보 안내',
  },

  CAR_DEPARTURE_INFO: {
    id: 13,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_CAR_DEPARTURE_INFO',
    label: '차량 출발 안내',
  },

  NEAR_EXPIARATION_DATE_INFO: {
    id: 14,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_NEAR_EXPIARATION_DATE_INFO',
    label: '계약 종료일 도래 안내',
  },

  RETURN_INFO: {
    id: 15,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_RETURN_INFO',
    label: '반납 안내 정보',
  },

  RETURN_COMPLETE_INFO: {
    id: 16,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_RETURN_COMPLETE_INFO',
    label: '반납후 청구 안내',
  },

  CREDIT_INSUFFICIENCY_INFO: {
    id: 17,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_CREDIT_INSUFFICIENCY_INFO',
    label: '신용조회 기준 미달 안내',
  },

  CREDIT_INQUIRY_AGREEMENT: {
    id: 18,
    group: 'SMS_SEND_HISTORY_TYPE',
    name: 'SSHTY_CREDIT_CREDIT_INQUIRY_AGREEMENT',
    label: '신용조회 동의 메세지',
  },

  get values() {
    return [
      this.INITIAL_CONTRACT,
      this.CREDIT_CHECK_FAIL,
      this.FELLOW_DRIVER,
      this.FELLOW_DRIVER_CONTRACTOR,
      this.DEPOSIT_INFO,
      this.INSURANCE_INFO,
      this.PLAN_INFO,
      this.WARRANTY_CONDITION_FAIL_INFO,
      this.DEPOSIT_CONFIRM,
      this.WARRANTY_CONDITION_FAIL_CONTRACT_CANCEL,
      this.CONTRACT_TERMINATION_BEFORE,
      this.CONTRACT_TERMINATION_AFTER,
      this.TAKE_OVER_INFO,
      this.CAR_DEPARTURE_INFO,
      this.NEAR_EXPIARATION_DATE_INFO,
      this.RETURN_INFO,
      this.RETURN_COMPLETE_INFO,
      this.CREDIT_INSUFFICIENCY_INFO,
      this.CREDIT_INQUIRY_AGREEMENT,
    ];
  },
};

const EmailSendHistoryType = {
  DEPOSIT_RETURN_INFO: {
    id: 0,
    group: 'EMAIL_SEND_HISTORY_TYPE',
    name: 'ESHTY_DEPOSIT_RETURN_INFO',
    label: '보증금 반환 정보',
  },

  DOCUMENT_MEMBER: {
    id: 1,
    group: 'EMAIL_SEND_HISTORY_TYPE',
    name: 'ESHTY_DOCUMENT_MEMBER',
    label: '계약서 (고객)',
  },

  DOCUMENT_INSURANCE: {
    id: 2,
    group: 'EMAIL_SEND_HISTORY_TYPE',
    name: 'ESHTY_DOCUMENT_INSURANCE',
    label: '계약서 (보험사)',
  },

  CANCEL_WARRANTY: {
    id: 3,
    group: 'EMAIL_SEND_HISTORY_TYPE',
    name: 'ESHTY_CANCEL_WARRANTY',
    label: '보증 취소 (보험사)',
  },

  BILL_REGULAR: {
    id: 4,
    group: 'EMAIL_SEND_HISTORY_TYPE',
    name: 'ESHTY_BILL_REGULAR',
    label: '정기 청구서',
  },

  BILL_EACH: {
    id: 5,
    group: 'EMAIL_SEND_HISTORY_TYPE',
    name: 'ESHTY_BILL_EACH',
    label: '개별 청구서',
  },

  BILL_RETURN: {
    id: 6,
    group: 'EMAIL_SEND_HISTORY_TYPE',
    name: 'ESHTY_BILL_RETURN',
    label: '반납 청구서',
  },

  get values() {
    return [
      this.DEPOSIT_RETURN_INFO,
      this.DOCUMENT_MEMBER,
      this.DOCUMENT_INSURANCE,
      this.CANCEL_WARRANTY,
      this.BILL_REGULAR,
      this.BILL_EACH,
      this.BILL_RETURN,
    ];
  },
};

const ContractDocumentState = {
  REQUESTED: {
    id: 0,
    group: 'CONTRACT_DOCUMENT_STATE',
    name: 'CDCST_REQUESTED',
    label: '대기중',
  },

  PROCESSING: {
    id: 1,
    group: 'CONTRACT_DOCUMENT_STATE',
    name: 'CDCST_PROCESSING',
    label: '처리중',
  },

  FAIL: {
    id: 2,
    group: 'CONTRACT_DOCUMENT_STATE',
    name: 'CDCST_FAIL',
    label: '실패',
  },

  COMPLETE: {
    id: 3,
    group: 'CONTRACT_DOCUMENT_STATE',
    name: 'CDCST_COMPLETE',
    label: '완료',
  },

  CANCELED: {
    id: 4,
    group: 'CONTRACT_DOCUMENT_STATE',
    name: 'CDCST_CANCELED',
    label: '취소',
  },

  get values() {
    return [
      this.REQUESTED,
      this.PROCESSING,
      this.FAIL,
      this.COMPLETE,
      this.CANCELED,
    ];
  },
};

const ContractDocumentEmailState = {
  WAITING: {
    id: 0,
    group: 'CONTRACT_DOCUMENT_EMAIL_STATE',
    name: 'CDEST_WAITING',
    label: '대기중',
  },

  PROCESSING: {
    id: 1,
    group: 'CONTRACT_DOCUMENT_EMAIL_STATE',
    name: 'CDEST_PROCESSING',
    label: '처리중',
  },

  FAIL: {
    id: 2,
    group: 'CONTRACT_DOCUMENT_EMAIL_STATE',
    name: 'CDEST_FAIL',
    label: '실패',
  },

  COMPLETE: {
    id: 3,
    group: 'CONTRACT_DOCUMENT_EMAIL_STATE',
    name: 'CDEST_COMPLETE',
    label: '완료',
  },

  get values() {
    return [
      this.WAITING,
      this.PROCESSING,
      this.FAIL,
      this.COMPLETE,
    ];
  },
};

const SettlementBillState = {
  REQUESTED: {
    id: 0,
    group: 'SETTLEMENT_BILL_STATE',
    name: 'SBLST_REQUESTED',
    label: '대기중',
  },

  PROCESSING: {
    id: 1,
    group: 'SETTLEMENT_BILL_STATE',
    name: 'SBLST_PROCESSING',
    label: '처리중',
  },

  FAIL: {
    id: 2,
    group: 'SETTLEMENT_BILL_STATE',
    name: 'SBLST_FAIL',
    label: '실패',
  },

  COMPLETE: {
    id: 3,
    group: 'SETTLEMENT_BILL_STATE',
    name: 'SBLST_COMPLETE',
    label: '완료',
  },

  get values() {
    return [
      this.REQUESTED,
      this.PROCESSING,
      this.FAIL,
      this.COMPLETE,
    ];
  },
};

const SettlementBillEmailState = {
  WAITING: {
    id: 0,
    group: 'SETTLEMENT_BILL_EMAIL_STATE',
    name: 'SBEST_WAITING',
    label: '대기중',
  },

  PROCESSING: {
    id: 1,
    group: 'SETTLEMENT_BILL_EMAIL_STATE',
    name: 'SBEST_PROCESSING',
    label: '처리중',
  },

  FAIL: {
    id: 2,
    group: 'SETTLEMENT_BILL_EMAIL_STATE',
    name: 'SBEST_FAIL',
    label: '실패',
  },

  COMPLETE: {
    id: 3,
    group: 'SETTLEMENT_BILL_EMAIL_STATE',
    name: 'SBEST_COMPLETE',
    label: '완료',
  },

  get values() {
    return [
      this.WAITING,
      this.PROCESSING,
      this.FAIL,
      this.COMPLETE,
    ];
  },
};

const WarrantyState = {
  WAITING: {
    id: 0,
    group: 'WARRANTY_STATE',
    name: 'WRTST_WAITING',
    label: '대기중',
  },

  ONGOING: {
    id: 1,
    group: 'WARRANTY_STATE',
    name: 'WRTST_ONGOING',
    label: '진행중',
  },

  COMPLETED: {
    id: 2,
    group: 'WARRANTY_STATE',
    name: 'WRTST_COMPLETED',
    label: '완료',
  },

  get values() {
    return [
      this.WAITING,
      this.ONGOING,
      this.COMPLETED,
    ];
  },
};

const TakeOverState = {
  WAITING: {
    id: 0,
    group: 'TAKE_OVER_STATE',
    name: 'TKOST_WAITING',
    label: '대기중',
  },

  ONGOING: {
    id: 1,
    group: 'TAKE_OVER_STATE',
    name: 'TKOST_ONGOING',
    label: '진행중',
  },

  COMPLETED: {
    id: 2,
    group: 'TAKE_OVER_STATE',
    name: 'TKOST_COMPLETED',
    label: '완료',
  },

  get values() {
    return [
      this.WAITING,
      this.ONGOING,
      this.COMPLETED,
    ];
  },
};

const ReturnState = {
  WAITING: {
    id: 0,
    group: 'RETURN_STATE',
    name: 'RTNST_WAITING',
    label: '대기중',
  },

  ONGOING: {
    id: 1,
    group: 'RETURN_STATE',
    name: 'RTNST_ONGOING',
    label: '진행중',
  },

  COMPLETED: {
    id: 2,
    group: 'RETURN_STATE',
    name: 'RTNST_COMPLETED',
    label: '완료',
  },

  EXTENDED: {
    id: 3,
    group: 'RETURN_STATE',
    name: 'RTNST_EXTENDED',
    label: '연장',
  },

  get values() {
    return [
      this.WAITING,
      this.ONGOING,
      this.COMPLETED,
      this.EXTENDED,
    ];
  },
};

const PenaltyState = {
  NONE: {
    id: 0,
    group: 'PENALTY_STATE',
    name: 'PNTST_NONE',
    label: '없음',
  },

  COMPLETED: {
    id: 1,
    group: 'PENALTY_STATE',
    name: 'PNTST_COMPLETED',
    label: '결제완료',
  },

  FAILED: {
    id: 2,
    group: 'PENALTY_STATE',
    name: 'PNTST_FAILED',
    label: '결제실패',
  },

  get values() {
    return [
      this.NONE,
      this.COMPLETED,
      this.FAILED,
    ];
  },
};

const CarGroupType = {
  BASIC: {
    id: 0,
    group: 'CAR_GROUP_TYPE',
    name: 'CGPTY_BASIC',
    label: '베이직 상품(국내차)',
  },

  PREMIUM: {
    id: 1,
    group: 'CAR_GROUP_TYPE',
    name: 'CGPTY_PREMIUM',
    label: '프리미엄 상품(수입차)',
  },

  get values() {
    return [
      this.BASIC,
      this.PREMIUM,
    ];
  },
};

const FellowDriverAgeType = {
  AGE_26_UP: {
    id: 0,
    group: 'FELLOW_DRIVER_AGE_TYPE',
    name: 'FDATY_AGE_26_UP',
    label: '만 26세 이상',
  },

  AGE_26_DOWN: {
    id: 1,
    group: 'FELLOW_DRIVER_AGE_TYPE',
    name: 'FDATY_AGE_26_DOWN',
    label: '만 26세 미만',
  },

  get values() {
    return [
      this.AGE_26_UP,
      this.AGE_26_DOWN,
    ];
  },
};

const ReasonType = {
  MONTHLY_SETTLEMENT_CLOSE: {
    id: 0,
    group: 'REASON_TYPE',
    name: 'RSNTP_MONTHLY_SETTLEMENT_CLOSE',
    label: '월정산마감',
  },

  PRICE_UPLOAD: {
    id: 1,
    group: 'REASON_TYPE',
    name: 'RSNTP_PRICE_UPLOAD',
    label: '요금제 업로드',
  },

  ETC_OPERATION: {
    id: 2,
    group: 'REASON_TYPE',
    name: 'RSNTP_ETC_OPERATION',
    label: '기타운영',
  },

  get values() {
    return [
      this.MONTHLY_SETTLEMENT_CLOSE,
      this.PRICE_UPLOAD,
      this.ETC_OPERATION,
    ];
  },
};

const ReservationState = {
  WAITING_CONTRACT_CONFIRM: {
    id: 0,
    group: 'RESERVATION_STATE',
    name: 'RSVST_WAITING_CONTRACT_CONFIRM',
    label: '계약확정대기',
  },

  WAITING_TAKE_OVER: {
    id: 1,
    group: 'RESERVATION_STATE',
    name: 'RSVST_WAITING_TAKE_OVER',
    label: '인수대기',
  },

  COMPLETED_TAKE_OVER: {
    id: 2,
    group: 'RESERVATION_STATE',
    name: 'RSVST_COMPLETED_TAKE_OVER',
    label: '인수완료',
  },

  COMPLETED_EXTEND: {
    id: 3,
    group: 'RESERVATION_STATE',
    name: 'RSVST_COMPLETED_EXTEND',
    label: '연장완료',
  },

  EXTENDABLE_CONTRACT: {
    id: 4,
    group: 'RESERVATION_STATE',
    name: 'RSVST_EXTENDABLE_CONTRACT',
    label: '연장가능',
  },

  WAITING_RETURN: {
    id: 5,
    group: 'RESERVATION_STATE',
    name: 'RSVST_WAITING_RETURN',
    label: '반납대기',
  },

  CONFIRMED_RETURN: {
    id: 6,
    group: 'RESERVATION_STATE',
    name: 'RSVST_CONFIRMED_RETURN',
    label: '반납확정',
  },

  COMPLETED_RETURN: {
    id: 7,
    group: 'RESERVATION_STATE',
    name: 'RSVST_COMPLETED_RETURN',
    label: '반납완료',
  },

  DELAYED_WAITING_RETURN: {
    id: 8,
    group: 'RESERVATION_STATE',
    name: 'RSVST_DELAYED_WAITING_RETURN',
    label: '반납지연(반납 대기)',
  },

  DELAYED_CONFIRMED_RETURN: {
    id: 9,
    group: 'RESERVATION_STATE',
    name: 'RSVST_DELAYED_CONFIRMED_RETURN',
    label: '반납지연(반납 확정)',
  },

  get values() {
    return [
      this.WAITING_CONTRACT_CONFIRM,
      this.WAITING_TAKE_OVER,
      this.COMPLETED_TAKE_OVER,
      this.COMPLETED_EXTEND,
      this.EXTENDABLE_CONTRACT,
      this.WAITING_RETURN,
      this.CONFIRMED_RETURN,
      this.COMPLETED_RETURN,
      this.DELAYED_WAITING_RETURN,
      this.DELAYED_CONFIRMED_RETURN,
    ];
  },
};

const CarTypeTagCategory = {
  THUMBNAIL: {
    id: 0,
    group: 'CAR_TYPE_TAG_CATEGORY',
    name: 'CTPTC_THUMBNAIL',
    label: '썸네일',
  },

  CAR_CLASS: {
    id: 0,
    group: 'CAR_TYPE_TAG_CATEGORY',
    name: 'CTPTC_CAR_CLASS',
    label: '차량 클래스',
  },

  OPTION: {
    id: 0,
    group: 'CAR_TYPE_TAG_CATEGORY',
    name: 'CTPTC_OPTION',
    label: '옵션',
  },

  get values() {
    return [
      this.THUMBNAIL,
      this.CAR_CLASS,
      this.OPTION,
    ];
  },
};

const CarProdtzType = {
  CONTRACT: {
    id: 0,
    group: 'CAR_PRODTZ_TYPE',
    name: 'PRDTP_CONTRACT',
    label: '상품화',
  },

  CAR_SHARING: {
    id: 1,
    group: 'CAR_PRODTZ_TYPE',
    name: 'PRDTP_CAR_SHARING',
    label: '존복귀',
  },

  SELL: {
    id: 2,
    group: 'CAR_PRODTZ_TYPE',
    name: 'PRDTP_SELL',
    label: '매각',
  },

  get values() {
    return [
      this.CONTRACT,
      this.CAR_SHARING,
      this.SELL,
    ];
  },
};

const CarProdtzState = {
  RECEIVE_WAITING: {
    id: 0,
    group: 'CAR_PRODTZ_STATE',
    name: 'PRODT_RECEIVE_WAITING',
    label: '입고대기',
  },

  RECEIVE_DELAYED: {
    id: 1,
    group: 'CAR_PRODTZ_STATE',
    name: 'PRODT_RECEIVE_DELAYED',
    label: '입고지연',
  },

  RECEIVE_COMPLETED: {
    id: 2,
    group: 'CAR_PRODTZ_STATE',
    name: 'PRODT_RECEIVE_COMPLETED',
    label: '입고완료 (점검중)',
  },

  RELEASE_DELAYED: {
    id: 3,
    group: 'CAR_PRODTZ_STATE',
    name: 'PRODT_RELEASE_DELAYED',
    label: '출고지연',
  },

  RELEASE_COMPLETED: {
    id: 4,
    group: 'CAR_PRODTZ_STATE',
    name: 'PRODT_RELEASE_COMPLETED',
    label: '출고완료',
  },

  CANCELED: {
    id: 5,
    group: 'CAR_PRODTZ_STATE',
    name: 'PRODT_CANCELED',
    label: '취소',
  },

  get values() {
    return [
      this.RECEIVE_WAITING,
      this.RECEIVE_DELAYED,
      this.RECEIVE_COMPLETED,
      this.RELEASE_DELAYED,
      this.RELEASE_COMPLETED,
      this.CANCELED,
    ];
  },
};

const CarOccupancyType = {
  CAR_PRODTZ: {
    id: 0,
    group: 'CAR_OCCUPANCY_TYPE',
    name: 'COPTY_CAR_PRODTZ',
    label: '상품화',
  },

  CONTRACT: {
    id: 1,
    group: 'CAR_OCCUPANCY_TYPE',
    name: 'COPTY_CONTRACT',
    label: '계약',
  },

  ETC: {
    id: 2,
    group: 'CAR_OCCUPANCY_TYPE',
    name: 'COPTY_ETC',
    label: '기타',
  },

  get values() {
    return [
      this.CAR_PRODTZ,
      this.CONTRACT,
      this.ETC,
    ];
  },
};

const CarCenterState = {
  IN_OPERATION: {
    id: 0,
    group: 'CAR_CENTER_STATE',
    name: 'CNTST_IN_OPERATION',
    label: '운영',
  },

  CLOSING: {
    id: 1,
    group: 'CAR_CENTER_STATE',
    name: 'CNTST_CLOSING',
    label: '미운영',
  },

  get values() {
    return [
      this.IN_OPERATION,
      this.CLOSING,
    ];
  },
};

const FollowupState = {
  WAITING: {
    id: 0,
    group: 'FOLLOWUP_STATE',
    name: 'FLUST_WAITING',
    label: '대기',
  },

  ONGOING: {
    id: 1,
    group: 'FOLLOWUP_STATE',
    name: 'FLUST_ONGOING',
    label: '진행중',
  },

  COMPLETED: {
    id: 2,
    group: 'FOLLOWUP_STATE',
    name: 'FLUST_COMPLETED',
    label: '완료',
  },

  CANCELED: {
    id: 3,
    group: 'FOLLOWUP_STATE',
    name: 'FLUST_CANCELED',
    label: '취소',
  },

  get values() {
    return [
      this.WAITING,
      this.ONGOING,
      this.COMPLETED,
      this.CANCELED,
    ];
  },
};

const FollowupType = {
  APPLICATION: {
    id: 0,
    group: 'FOLLOWUP_TYPE',
    name: 'FLUTP_APPLICATION',
    label: '신청',
  },

  CONTRACT: {
    id: 1,
    group: 'FOLLOWUP_TYPE',
    name: 'FLUTP_CONTRACT',
    label: '계약',
  },

  CAR_PRODTZ: {
    id: 2,
    group: 'FOLLOWUP_TYPE',
    name: 'FLUTP_CAR_PRODTZ',
    label: '상품화',
  },

  get values() {
    return [
      this.APPLICATION,
      this.CONTRACT,
      this.CAR_PRODTZ,
    ];
  },
};

const TakeOverLocationType = {
  APT: {
    id: 0,
    group: 'TAKE_OVER_LOCATION_TYPE',
    name: 'TKOTP_APT',
    label: '아파트/오피스텔',
    message: '차량 방문 허가를 위해 반드시 동, 호수를 입력해주세요. 예) 쏘카아파트 101동 1001호입니다. 지하 2층 C구역에 주차해주세요.',
  },

  BUILDING: {
    id: 1,
    group: 'TAKE_OVER_LOCATION_TYPE',
    name: 'TKOTP_BUILDING',
    label: '빌딩/상가/관공서',
    message: '건물명과 희망하는 주차 위치를 작성해주세요. 예) 쏘카 빌딩 지하 2층 C구역에 주차해주세요.',
  },

  VILLA: {
    id: 2,
    group: 'TAKE_OVER_LOCATION_TYPE',
    name: 'TKOTP_VILLA',
    label: '빌라/주택',
    message: '주차가 가능한 위치를 자세히 작성해주세요.',
  },

  PARKING: {
    id: 3,
    group: 'TAKE_OVER_LOCATION_TYPE',
    name: 'TKOTP_PARKING',
    label: '일반/공영 주차장',
    message: '희망하는 주차 위치를 자세히 작성해주세요.',
  },

  ETC: {
    id: 4,
    group: 'TAKE_OVER_LOCATION_TYPE',
    name: 'TKOTP_ETC',
    label: '기타',
    message: '희망하는 주차 위치를 자세히 작성해주세요.',
  },

  get values() {
    return [
      this.APT,
      this.BUILDING,
      this.VILLA,
      this.PARKING,
      this.ETC,
    ];
  },
};

const CarModel = {
  SMALL: {
    id: 0,
    group: 'CAR_MODEL',
    name: 'CARMODEL_SMALL',
    label: '경형/소형',
  },

  MEDIUM: {
    id: 1,
    group: 'CAR_MODEL',
    name: 'CARMODEL_MEDIUM',
    label: '준중형',
  },

  LARGE: {
    id: 2,
    group: 'CAR_MODEL',
    name: 'CARMODEL_LARGE',
    label: '중형/대형',
  },

  IMPORT: {
    id: 3,
    group: 'CAR_MODEL',
    name: 'CARMODEL_IMPORT',
    label: '수입',
  },

  SUV: {
    id: 4,
    group: 'CAR_MODEL',
    name: 'CARMODEL_SUV',
    label: 'SUV',
  },

  get values() {
    return [
      this.SMALL,
      this.MEDIUM,
      this.LARGE,
      this.IMPORT,
      this.SUV,
    ];
  },
};

const SortByPrice = {
  ASC: {
    id: 0,
    group: 'SORT_BY_PRICE',
    name: 'STBP_ASC',
    label: '낮은 가격 순',
  },

  DESC: {
    id: 1,
    group: 'SORT_BY_PRICE',
    name: 'STBP_DESC',
    label: '높은 가격 순',
  },

  get values() {
    return [
      this.ASC,
      this.DESC,
    ];
  },
};

const MaxRentMethodType = {
  AUTO_UPDATE: {
    id: 0,
    group: 'MAX_RENT_METHOD_TYPE',
    name: 'MRMTY_AUTO_UPDATE',
    label: '자동 업데이트 (매일 오전 6시)',
  },

  MANUAL: {
    id: 1,
    group: 'MAX_RENT_METHOD_TYPE',
    name: 'MRMTY_MANUAL',
    label: '수기 관리',
  },

  get values() {
    return [
      this.AUTO_UPDATE,
      this.MANUAL,
    ];
  },
};

export default {
  applicationState: ApplicationState,

  applicationTagCategory: ApplicationTagCategory,

  insurancePriceType: InsurancePriceType,

  insurancePriceAgeType: InsurancePriceAgeType,

  contractState: ContractState,

  warrantyTarget: WarrantyTarget,

  warrantyType: WarrantyType,

  warrantyProcessState: WarrantyProcessState,

  warrantyPurchaseState: WarrantyPurchaseState,

  contractDocumentType: ContractDocumentType,

  contractDocumentTarget: ContractDocumentTarget,

  carConsignmentState: CarConsignmentState,

  carGradeType: CarGradeType,

  carConsignmentType: CarConsignmentType,

  carConsignmentMethod: CarConsignmentMethod,

  attachmentType: AttachmentType,

  historyContentType: HistoryContentType,

  managerType: ManagerType,

  categoryType: CategoryType,

  settlementType: SettlementType,

  settlementChargeType: SettlementChargeType,

  settlementPaymentType: SettlementPaymentType,

  settlementChargeState: SettlementChargeState,

  settlementState: SettlementState,

  settlementItemType: SettlementItemType,

  settlementAccountingType: SettlementAccountingType,

  settlementPaymentState: SettlementPaymentState,

  excelType: ExcelType,

  excelUploadState: ExcelUploadState,

  excelDownloadState: ExcelDownloadState,

  zipFileType: ZipFileType,

  zipFileDownloadState: ZipFileDownloadState,

  smsSendHistoryType: SmsSendHistoryType,

  emailSendHistoryType: EmailSendHistoryType,

  contractDocumentState: ContractDocumentState,

  contractDocumentEmailState: ContractDocumentEmailState,

  settlementBillState: SettlementBillState,

  settlementBillEmailState: SettlementBillEmailState,

  warrantyState: WarrantyState,

  takeOverState: TakeOverState,

  returnState: ReturnState,

  penaltyState: PenaltyState,

  carGroupType: CarGroupType,

  fellowDriverAgeType: FellowDriverAgeType,

  reasonType: ReasonType,

  reservationState: ReservationState,

  carTypeTagCategory: CarTypeTagCategory,

  carProdtzType: CarProdtzType,

  carProdtzState: CarProdtzState,

  carOccupancyType: CarOccupancyType,

  carCenterState: CarCenterState,

  followupState: FollowupState,

  followupType: FollowupType,

  takeOverLocationType: TakeOverLocationType,

  carModel: CarModel,

  sortByPrice: SortByPrice,

  maxRentMethodType: MaxRentMethodType,
};
